import { createSelector, Selector } from '@reduxjs/toolkit'
import { AxeDetail } from 'selectors/axeSelectors'
import { axeDetailIsSBL } from 'view/routes/axeBoard/components/axeModelUtils'
import {
  instrumentIsEligibleForSBLSelector,
  tradingEntitiesForOrganisationsGetterSelector,
  authorisedUserIsPermissionedToTradeInstrumentSelector,
  createTradingEntityIsPermissionedToTradeInstrumentSelector,
  FilterType,
  instrumentIsPermittedToBePrimarySelector,
  instrumentCanBeTradedByAuthorisedUserSelector,
  createInstrumentCanBeTradedByTradingEntitySelector
} from './instrumentFilterSelectors'

export const createInstrumentFiltersForAxeCollateralSelector = <P>(axeDetailSelector: Selector<{}, AxeDetail, [P]>) =>
  createSelector(
    [
      axeDetailSelector,
      instrumentIsEligibleForSBLSelector,
      createInstrumentCanBeTradedByTradingEntitySelector,
      tradingEntitiesForOrganisationsGetterSelector,
      instrumentCanBeTradedByAuthorisedUserSelector,
      authorisedUserIsPermissionedToTradeInstrumentSelector,
      createTradingEntityIsPermissionedToTradeInstrumentSelector,
      instrumentIsPermittedToBePrimarySelector
    ],
    (
      axeDetail,
      instrumentIsEligibleForSBL,
      createInstrumentCanBeTradedByTradingEntities,
      getTradingEntitiesForOrganisations,
      instrumentCanBeTradedByAuthorisedUser,
      authorisedUserIsPermissionedToTradeInstrument,
      tradingEntityIsPermissionedToTradeInstrument,
      instrumentIsPermittedToBePrimary
    ) => {
      const {
        axe: { initiatorTradingEntityId, marketType }
      } = axeDetail
      const counterpartyIds = getTradingEntitiesForOrganisations(axeDetail.axe.responderOrganisationIds ?? []).map(te => te.id)
      const fundIds = initiatorTradingEntityId ? [initiatorTradingEntityId] : []

      return [
        instrumentCanBeTradedByAuthorisedUser(marketType),
        instrumentIsPermittedToBePrimary,
        createInstrumentCanBeTradedByTradingEntities(marketType, fundIds),
        createInstrumentCanBeTradedByTradingEntities(marketType, counterpartyIds, FilterType.OR),
        authorisedUserIsPermissionedToTradeInstrument,
        tradingEntityIsPermissionedToTradeInstrument(fundIds),
        tradingEntityIsPermissionedToTradeInstrument(counterpartyIds, FilterType.OR),
        ...(axeDetailIsSBL(axeDetail) ? [instrumentIsEligibleForSBL] : [])
      ]
    }
  )
